export default "__VITE_ASSET__U8M5V00m__"